import React from "react";

function StickerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Sticker_Icon"
        data-name="Sticker Icon"
        transform="translate(-0.353)"
      >
        <circle
          id="Ellipse_2337"
          data-name="Ellipse 2337"
          cx="24"
          cy="24"
          r="24"
          transform="translate(0.353)"
          opacity="0.7"
        />
        <path
          id="Sticker_Icon-2"
          data-name="Sticker Icon"
          d="M12.363,23.727a12.1,12.1,0,0,1,1.005-4.13,8.486,8.486,0,0,1-4.881-2.132l1.622-1.813A6.054,6.054,0,0,0,14.163,17.2a6.154,6.154,0,0,0,.634-.033,12.147,12.147,0,0,1,8.93-4.806A9.731,9.731,0,1,0,12.363,23.727Zm10.343-8.791a9.741,9.741,0,0,0-7.769,7.769Zm3.621-.774q0,.306-.015.608l-11.54,11.54q-.3.015-.608.015A12.163,12.163,0,1,1,26.326,14.163ZM11.73,11.73A1.824,1.824,0,1,1,9.906,9.906,1.824,1.824,0,0,1,11.73,11.73Zm8.514,0A1.824,1.824,0,1,1,18.42,9.906,1.824,1.824,0,0,1,20.244,11.73Z"
          transform="translate(10.081 10.163)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default StickerIcon;
